import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import './assets/icon/iconfont.css'
import adminApi from './util/common.js';
import { ensureSiteConfig, siteConfigState } from './util/site-config';
import 'iconify-icon'
import axios from 'axios';

Vue.prototype.$iconify = true
Vue.config.productionTip = false

Vue.use(ElementUI);

Vue.prototype.adminApi = adminApi;

var https = axios.create({
  baseURL: adminApi.admin_api,
  timeout: 5000,
});

https.interceptors.request.use(function (config) {
  const token = sessionStorage.getItem('token');
  var is_login = config.url.indexOf('login') == -1 ? false : true;
  if (!is_login && token) {
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

https.interceptors.response.use((response) => {
  if (response.data) {
    if (response.data.code == 401) {
      router.push('/login');
    } else {
      return response.data
    }
  } else {
    return response.data;
  }
}, function (error) {
  return Promise.reject(error);
});

Vue.prototype.axios = https;
Vue.prototype.$siteConfigState = siteConfigState;

Object.defineProperty(Vue.prototype, '$siteConfig', {
  get() {
    return siteConfigState.data;
  },
});

const syncDocumentTitle = () => {
  document.title = siteConfigState.data.site_title || '协会官网';
};

syncDocumentTitle();

router.beforeEach(async (to, from, next) => {
  // const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // if (/android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
  //   const mobileSiteUrl = adminApi.MOBILE_SITE_URL;
  //   window.location.href = mobileSiteUrl;
  //   return;
  // }
  try {
    await ensureSiteConfig(https);
    syncDocumentTitle();
  } catch (error) {
    console.error('获取网站配置失败:', error);
  }
  next();
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
